module.exports = __webpack_public_path__ + "img/consult_info1.03ea8d41.png";